import React, { useEffect, useState } from 'react';
import { Select, Table, Typography } from 'antd';
import marketDataService from '../../services/MarketDataService';
import { v4 as uuidv4 } from 'uuid';
import { convertToLocal } from '../../components/Functions/convertToLocal';
import { useAuth } from '../../hooks/useAuth';

const { Title, Text } = Typography;

const MarketWatch = () => {
  const [marketDataList, setMarketDataList] = useState([]);
  const [intervalTime, setIntervalTime] = useState(10000); // Default interval of 1 second
  const { showNotification } = useAuth();

  // Table columns
  const tableColumns = [
    {
      title: 'Security Name',
      dataIndex: 'securityName',
      key: 'securityName',
    },
    {
      title: 'Security Type',
      dataIndex: 'securityType',
      key: 'securityType',
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
    },
    {
      title: 'Company Code',
      dataIndex: 'companyCode',
      key: 'companyCode',
    },
    {
      title: 'Security Code',
      dataIndex: 'securityCode',
      key: 'securityCode',
    },
    {
      title: 'Opeining Price',
      dataIndex: 'openingPrice',
      key: 'openingPrice',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
      // removed duplicates first
      //   filters: [...new Set(applicationList.map(item => item.eyeColor))].map(item => {
      //     return {
      //       text: item,
      //       value: item,
      //     };
      //   }),
      //   onFilter: (value, record) => record.eyeColor.startsWith(value),
    },
    {
      title: 'Opening Price Timestamp',
      dataIndex: 'openingPriceTimestamp',
      key: 'openingPriceTimestamp',
      align: 'right',
      render: (_, record) => convertToLocal(record.openingPriceTimestamp),
    },
    {
      title: 'High Price',
      dataIndex: 'highPrice',
      key: 'highPrice',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'High Price Timestamp',
      dataIndex: 'highPriceTimestamp',
      key: 'highPriceTimestamp',
      align: 'right',
      render: (_, record) => convertToLocal(record.highPriceTimestamp),
    },
    // {
    //   title: 'Stop Limit High',
    //   dataIndex: 'stopLimitHigh',
    //   key: 'stopLimitHigh',
    // },
    {
      title: 'Low Price',
      dataIndex: 'lowPrice',
      key: 'lowPrice',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Low Price Timestamp',
      dataIndex: 'lowPriceTimestamp',
      key: 'lowPriceTimestamp',
      align: 'right',
      render: (_, record) => convertToLocal(record.lowPriceTimestamp),
    },
    // {
    //   title: 'Stop Limit Low',
    //   dataIndex: 'stopLimitLow',
    //   key: 'stopLimitLow',
    // },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Price Timestamp',
      dataIndex: 'priceTimestamp',
      key: 'priceTimestamp',
      align: 'right',
      render: (_, record) => convertToLocal(record.priceTimestamp),
    },
    {
      title: 'Closing Price',
      dataIndex: 'closingPrice',
      key: 'closingPrice',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Closing Price Timestamp',
      dataIndex: 'closingPriceTimestamp',
      key: 'closingPriceTimestamp',
      align: 'right',
      render: (_, record) => convertToLocal(record.closingPriceTimestamp),
    },
    {
      title: 'Turn Over',
      dataIndex: 'turnover',
      key: 'turnover',
      align: 'right',
    },
    {
      title: 'Trade Amount',
      dataIndex: 'tradeAmount',
      key: 'tradeAmount',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
  ];

  const loadData = async () => {
    const response = await marketDataService.getMarketDataList();
    console.log(response);
    if (response.success === true) {
      setMarketDataList(
        response.marketDataList.map((marketData, i) => ({ ...marketData, key: i })),
      );
    } else {
      showNotification('error', response.message);
    }
  };

  // useEffect(() => {
  //   loadData();
  // }, []);

  // Effect hook to schedule interval refresh
  useEffect(() => {
    // Fetch data initially
    loadData();

    // Schedule a refresh based on the selected interval
    const intervalId = setInterval(() => {
      loadData();
    }, intervalTime);

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [intervalTime]);

  // Function to handle interval change
  const handleIntervalChange = value => {
    setIntervalTime(value);
  };

  return (
    <>
      <section
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Market Watch
        </Title>
        <Select defaultValue={10000} onChange={handleIntervalChange}>
          <Select.Option value={10000}>10 second</Select.Option>
          <Select.Option value={30000}>30 seconds</Select.Option>
          <Select.Option value={50000}>50 seconds</Select.Option>
        </Select>
        {/* <Button
          type="primary"
          size={'large'}
          icon={<ReloadOutlined />}
          onClick={() => loadData}
        >
          Refresh
        </Button> */}
      </section>
      <Table
        columns={tableColumns}
        dataSource={marketDataList}
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        bordered
        rowKey="marketId"
      />
    </>
  );
};

export default MarketWatch;
